import {
  Box,
  Button,
  Grid,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { ColorPickerColors } from '../../../models/ColorPicker';
import ColorBlock from './partials/ColorBlock';
import Sketcher from './Sketcher';
import ColorUtils from '../../../utils/ColorUtils';

interface ColorPickerProps {
  value: string;
  hasColorText?: boolean;
  onPickColor: (color: string | ColorPickerColors) => void;
}

const ColorPicker = ({ value = '', hasColorText, onPickColor }: ColorPickerProps) => {
  const [hexadecimal, setHexadecimal] = useState<string>(ColorUtils.convert(value));
  const [isSkecthOpen, setIsSkecthOpen] = useState<boolean>(false);

  useEffect(() => {
    setHexadecimal(ColorUtils.convert(value));
  }, [value]);

  const onPickColorLocal = useCallback((color: string) => {
    const colorHex = ColorUtils.convert(color);
    onPickColor(colorHex);
    setHexadecimal(colorHex);
  }, [onPickColor]);

  return (
    <>
      <Box
        sx={{
          padding: 0.5,
          backgroundColor: '#f5f5f5',
          borderRadius: '2px',
        }}
      >
        <Grid container>
          <ColorBlock color={ColorPickerColors.BLACK} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.WHITE} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.RED} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.PINK} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.PURPLE} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.DEEP_PURPLE} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.INDIGO} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.BLUE} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.LIGHT_BLUE} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.CYAN} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
        </Grid>
        <Grid container>
          <ColorBlock color={ColorPickerColors.SILVER} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.GRAY} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.TEAL} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.GREEN} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.LIGHT_GREEN} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.LIME} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.YELLOW} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.AMBER} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          <ColorBlock color={ColorPickerColors.ORANGE} picked={value as ColorPickerColors} onPick={onPickColorLocal} />
          {hasColorText ? (
            <ColorBlock
              color={ColorPickerColors.DEFAULT_TEXT}
              picked={value as ColorPickerColors}
              onPick={() => {
                onPickColor(ColorPickerColors.DEFAULT_TEXT);
                setHexadecimal('');
              }}
            />
          ) : (
            <ColorBlock color={ColorPickerColors.DEFAULT} picked={value as ColorPickerColors} onPick={() => onPickColorLocal(ColorPickerColors.DEFAULT)} />
          )}
        </Grid>
      </Box>
      <div
        style={{
          display: 'flex',
          marginTop: '3px',
          alignItems: 'center',
        }}
      >
        <input
          value={hexadecimal}
          onChange={(e) => {
            const value = (e?.target?.value.startsWith('#') || e.target.value === '') ? e.target.value : `#${e.target.value}`;
            setHexadecimal(value);
            onPickColor(value);
          }}
          type="text"
          style={{
            height: '30px', border: '1px solid #ced4da', borderRadius: '2px',
          }}
        />

        <Button
          type="button"
          className="btn ms-2 border border-1"
          onClick={() => {
            setIsSkecthOpen(!isSkecthOpen);
          }}
        >
          . . .
        </Button>

        {isSkecthOpen && (
          <Sketcher
            hexadecimal={hexadecimal}
            setHexadecimal={setHexadecimal}
            setIsSkecthOpen={setIsSkecthOpen}
            onPickColor={onPickColorLocal}
          />
        )}
      </div>
    </>
  );
};
export default ColorPicker;
